import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  MALAYALAM_TTS_FEMALE_SPEAKER,
  MalayalamTtsSynthesizeRequest,
} from '../models/malayalam-tts.model';
import { apiList } from './apiList.service';

const SILENT_HEADERS = new HttpHeaders({
  'X-Skip-Success-Toaster': 'true',
  'X-Skip-Error-Toaster': 'true',
});

/**
 * HTTP access for Malayalam server-side TTS (Indic Parler-TTS, female Anjali).
 */
@Injectable({ providedIn: 'root' })
export class MalayalamTtsRepository {
  private readonly http = inject(HttpClient);
  private readonly endpoints = inject(apiList);

  /** Lightweight ping so the TTS worker is warm before the AI chat opens. */
  warmup(signal?: AbortSignal): Observable<void> {
    return this.http.get<void>(`${environment.base_url}${this.endpoints.malayalamTtsWarmup}`, {
      headers: SILENT_HEADERS,
      ...(signal ? { signal } : {}),
    });
  }

  /** Synthesizes Malayalam speech audio for the given text. */
  synthesize(
    text: string,
    options: { prefetch?: boolean; signal?: AbortSignal } = {},
  ): Observable<Blob> {
    const body: MalayalamTtsSynthesizeRequest = {
      text,
      speaker: MALAYALAM_TTS_FEMALE_SPEAKER,
      prefetch: options.prefetch,
    };

    return this.http.post(`${environment.base_url}${this.endpoints.malayalamTts}`, body, {
      responseType: 'blob',
      headers: SILENT_HEADERS,
      ...(options.signal ? { signal: options.signal } : {}),
    });
  }
}
